export default "__VITE_ASSET__CHEFsK3Z__"